"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createCleanQueryString = void 0;
var query_string_1 = require("query-string");
var createCleanQueryString = function (_a) {
    var query = _a.query;
    return (0, query_string_1.stringify)(query, { skipNull: true });
};
exports.createCleanQueryString = createCleanQueryString;
